// Pure helpers behind the box-preparation board.

const STORE_COLORS = ["#7c3aed", "#0891b2", "#c026d3", "#ea580c", "#16a34a", "#db2777", "#2563eb", "#ca8a04"];

// The same store always gets the same colour, on every screen and every visit.
export function storeColor(storeId) {
  let hash = 0;
  for (const ch of String(storeId)) hash = (hash * 31 + ch.charCodeAt(0)) >>> 0;
  return STORE_COLORS[hash % STORE_COLORS.length];
}

// ready = locked, dims = weight entered, need = still waiting for weight and size
export const boxState = (box) => (box.ready ? "ready" : box.weight ? "dims" : "need");

const sumOf = (rows, key) => rows.reduce((total, row) => total + (row[key] || 0), 0);

export function storeTotals(store) {
  return {
    planned: sumOf(store.items, "planned"),
    boxed: sumOf(store.items, "boxed"),
    left: store.items.reduce((total, item) => total + Math.max(item.remaining, 0), 0),
  };
}

export function boxingTotals(stores, boxes) {
  const totals = stores.map(storeTotals);
  return {
    planned: sumOf(totals, "planned"),
    boxed: sumOf(totals, "boxed"),
    boxCount: boxes.length,
    readyCount: boxes.filter(b => b.ready).length,
  };
}

export function labelCounts(boxes) {
  const counts = { NONE: 0, READY: 0, APPLIED: 0 };
  boxes.forEach(b => { counts[b.label_state] += 1; });
  return counts;
}

// The boxes of a store grouped by the label file they share (the tenant picked the boxes when uploading it).
export function groupByLabelFile(boxes) {
  const groups = new Map();
  boxes.forEach(box => (box.labels || []).forEach(label => {
    if (!label.file_url) return;
    const group = groups.get(label.file_url) || { url: label.file_url, name: label.original_filename, boxes: [] };
    group.boxes.push(box);
    groups.set(label.file_url, group);
  }));
  return [...groups.values()];
}

// Per ASIN, how many units arrived damaged or never arrived; ASINs without a problem are left out.
export function discrepancyFlags(rows) {
  const flags = {};
  rows.forEach(row => {
    if (row.damaged > 0 || row.missing > 0) flags[row.asin] = { damaged: row.damaged, missing: row.missing };
  });
  return flags;
}
